module.exports = "/_next/static/images/calendar-b508bb11ed4313b7fc96a7b2c53f82ea.svg";